module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agentSummary":"Agent Summary"},"es":{"agentSummary":"Resumen del agente"}}')
  delete Component.options._Ctor
}
